/* ============================================================
   ARKAVEDA PRODUCT ACCORDIONS
============================================================ */
(function () {
  'use strict';

  function initArkAccordions() {
    var buttons = document.querySelectorAll(
      '.ark-product-info-accordions .ark-info-accordion__button'
    );

    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.arkAccordionInitialized === 'true') return;
      button.dataset.arkAccordionInitialized = 'true';

      button.addEventListener('click', function () {
        var contentId = button.getAttribute('aria-controls');
        var content = document.getElementById(contentId);
        if (!content) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          button.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
          content.classList.remove('is-open');
        } else {
          button.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          content.classList.add('is-open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArkAccordions);
  } else {
    initArkAccordions();
  }

  document.addEventListener('shopify:section:load', initArkAccordions);
})();